import { render, staticRenderFns } from "./projectReviewRuleIndex.vue?vue&type=template&id=404e6e0c&scoped=true&"
import script from "./projectReviewRuleIndex.vue?vue&type=script&lang=js&"
export * from "./projectReviewRuleIndex.vue?vue&type=script&lang=js&"
import style0 from "./projectReviewRuleIndex.vue?vue&type=style&index=0&id=404e6e0c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "404e6e0c",
  null
  
)

export default component.exports